import { type FormSubmission } from "@overmap-ai/common"
import { FormSubmissionFieldValuesService as OvermapFormSubmissionFieldValuesService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import { FIELD_VALUES_PAGINATION_PAGE_SIZE } from "../constants"
import type { AppSDK } from "../sdk"

export class FormSubmissionFieldValuesService extends OvermapFormSubmissionFieldValuesService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
	pageSize = FIELD_VALUES_PAGINATION_PAGE_SIZE

	async refreshStoreForFormSubmission(formSubmissionId: FormSubmission["uuid"], signal?: AbortSignal) {
		const { addMany } = this.actions

		const result = await this.listPaginated(
			{
				queryParams: {
					form_submission: formSubmissionId,
				},
			},
			signal,
		)

		const flattened = result.flat()
		this.dispatch(addMany(flattened))
		return flattened
	}
}
